<script setup lang="ts">
defineProps({
  width: {
    type: [Number, String],
    default: 15,
  },
  height: {
    type: [Number, String],
    default: 20,
  },
  iconColor: {
    type: String,
    default: 'white',
  },
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 25"
    aria-label="Eco-friendly"
  >
    <path
      id="Vector" d="M4.23622 21.4923C4.11877 21.9676 3.90642 22.4157 3.75319 22.8781C3.59995 23.3406 3.47083 24.3014 3.0998 24.5956C2.46119 25.1036 1.52701 24.5988 1.57135 23.8047C1.59235 23.4307 1.94549 22.4635 2.08005 22.0577C3.66607 17.2959 6.76809 12.739 10.613 9.61579C11.1901 9.14694 12.2736 8.06494 12.9706 8.88382C13.848 9.91559 12.2309 10.7329 11.6031 11.287C8.90948 13.6623 6.66308 16.5009 5.0514 19.7597C7.74039 20.7644 10.7724 21.0283 13.221 19.2717C17.8733 15.9348 17.8764 9.49299 16.6677 4.36044C16.5525 3.87086 16.4141 3.23139 16.236 2.77211C16.2126 2.71151 16.2671 2.67005 16.1442 2.68999C13.3206 5.77255 8.77803 5.28218 5.40532 7.43902C2.40441 9.35824 1.31544 12.9368 2.05205 16.4172C2.15395 16.8988 2.51564 17.7009 2.49386 18.1187C2.4433 19.0955 1.19254 19.31 0.73128 18.4871C-0.0986744 17.0112 -0.132121 13.7022 0.186793 12.0605C1.04475 7.64872 4.19578 5.40975 8.16431 4.18343C10.641 3.41797 13.2 3.23298 15.0365 1.14153C15.4814 0.635209 15.6829 -0.0210123 16.4919 0.00051625C17.125 0.0172606 17.3973 0.410355 17.6119 0.946176C18.8674 4.07658 19.4834 8.86069 19.0743 12.2032C18.3595 18.0334 14.2579 22.9515 8.16587 22.4468C6.81943 22.3351 5.4971 21.9604 4.23545 21.4923H4.23622Z"
      :fill="iconColor"
    />
  </svg>
</template>
